module.exports = __webpack_public_path__ + "static/media/emmanuel.5624fd9e.svg";